<template>
  <div class="h70pc">
    <div class="content">
      <h1 style="color: #4a4a4a">你的性别:</h1>
      <br />
      <div class="left" @click="changeGender(0)">
        <img style="width: 72px" v-lazy="male[maleFlag]" />
      </div>
      <div class="right" @click="changeGender(1)">
        <img style="width: 72px" v-lazy="female[femalFlag]" />
      </div>
    </div>
    <div class="age">
      <h1 style="color: #4a4a4a">你的年龄:</h1>
      <br />
      <input v-model="age" @blur="inputBlur" @input="checkInput" />
    </div>
    <van-button @click="next()" class="next">下一步</van-button>
  </div>
</template>

<script>
import { setInfo } from "@/http/api";
import store from "./../../../store/index";
import { mapGetters } from "vuex";
export default {
  name: "gender",
  data() {
    return {
      male: [
        require("./../../../assets/img/test/male_ori.png"),
        require("./../../../assets/img/test/male.png"),
      ],
      female: [
        require("./../../../assets/img/test/female_ori.png"),
        require("./../../../assets/img/test/female.png"),
      ],
      gender: -1,
      maleFlag: 0,
      femalFlag: 0,
      age: "",
      old: "",
    };
  },
  computed: {
    ...mapGetters(["user", "user_id", "eval_id"]),
  },
  methods: {
    checkInput(e) {
      const reg = /^(0|([1-9]\d?)|(1[01]\d)|(120))(\.\d*)?$/;
      if (reg.test(e.target.value) || !e.target.value) {
        this.old = e.target.value;
        this.value = e.target.value;
      } else {
        this.age = this.old;
      }
    },
    // 输入框关闭软键盘
    inputBlur() {
      // window.scroll(0, 0);
      setTimeout(() => {
        // alert(1);
        if (
          document.activeElement.tagName === "INPUT" ||
          document.activeElement.tagName === "TEXTAREA"
        ) {
          return;
        }
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          // 判断iPhone|iPad|iPod|iOS
          this.valRes = "ios";
        } else if (/(Android)/i.test(navigator.userAgent)) {
          // 判断Android
          this.valRes = "android";
        }
        // if (this.valRes === 'ios') {
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
        // document.querySelectorAll(".vd-content")[0].scrollTop = 0;
        // window.scrollTo(0)
        // }
        document.querySelector("body").scrollIntoView(true);
        document.activeElement.scrollIntoViewIfNeeded(true);
        // }
      }, 10);
    },
    // 设置性别和年龄
    next() {
      if (this.gender !== -1 && this.age) {
        let setting = {
          gender: +this.gender,
          age: this.age,
          evaluation: this.eval_id,
        };
        store.commit("set_gender", setting);
        try {
          setInfo(setting).then((res) => {
            console.log("创建res", res);
            store.commit("set_appraisal_id", res.data.id);
          });
        } catch (err) {
          alert("请求失败了", err);
        }

        this.$router.push("./note");
      } else {
        this.$message({
          message: "请设置性别和年龄",
          type: "error",
        });
      }
    },
    // 改变性别
    changeGender(index) {
      if (!index) {
        this.maleFlag = 1;
        this.femalFlag = 0;
      } else {
        this.maleFlag = 0;
        this.femalFlag = 1;
      }
      this.gender = index;
      console.log(this.gender);
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  padding-top: 18%;
  height: 4rem;
  width: 80%;
  margin-left: 10%;
  h1 {
    margin-left: 8%;
    font-size: larger;
    margin-bottom: 20px;
  }
  .left {
    width: 50%;
    float: left;
  }
  .right {
    width: 50%;
    float: right;
  }
  img {
    // width: 50%;
    // position: relative;
    margin: 0 auto;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
  }
}
.age {
  margin-left: 18%;
  margin-top: 50%;
  h1 {
    font-size: larger;
  }
  input {
    // width: 60%;
    text-align: center;
    border-radius: 8px;
    line-height: 1rem;
    width: 80%;
    background-color: #eceff5;
    border: 1px solid #ededed;
  }
}
.next {
  width: 90%;
  text-align: center;
  line-height: 25px;
  margin-left: 5%;
  border-radius: 18px;
  margin-top: 40%;
  background-color: #42686e;
  color: white;
}
</style>
